/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as NotAuthedRouteRouteImport } from "./routes/_not-authed/route";
import { Route as AuthedRouteRouteImport } from "./routes/_authed/route";
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index";
import { Route as NotAuthedSignUpRouteImport } from "./routes/_not-authed/sign-up";
import { Route as NotAuthedSignInRouteImport } from "./routes/_not-authed/sign-in";
import { Route as AuthedMyPlayersRouteRouteImport } from "./routes/_authed/my-players/route";
import { Route as AuthedMyClansRouteRouteImport } from "./routes/_authed/my-clans/route";
import { Route as AuthedMyPlayersIndexRouteImport } from "./routes/_authed/my-players/index";
import { Route as AuthedMyClansIndexRouteImport } from "./routes/_authed/my-clans/index";
import { Route as AuthedClanWarPlannerIndexRouteImport } from "./routes/_authed/clan-war-planner/index";
import { Route as AuthedMyPlayersTagRouteRouteImport } from "./routes/_authed/my-players/$tag/route";
import { Route as AuthedMyClansTagRouteRouteImport } from "./routes/_authed/my-clans/$tag/route";
import { Route as AuthedMyPlayersTagIndexRouteImport } from "./routes/_authed/my-players/$tag/index";
import { Route as AuthedMyClansTagIndexRouteImport } from "./routes/_authed/my-clans/$tag/index";
import { Route as AuthedMyPlayersTagSocialMediaRouteImport } from "./routes/_authed/my-players/$tag/social-media";
import { Route as AuthedMyPlayersTagSearchFilterRouteImport } from "./routes/_authed/my-players/$tag/search-filter";
import { Route as AuthedMyPlayersTagNotificationsRouteImport } from "./routes/_authed/my-players/$tag/notifications";
import { Route as AuthedMyPlayersTagMatchsRouteImport } from "./routes/_authed/my-players/$tag/matchs";
import { Route as AuthedMyPlayersTagClansRouteImport } from "./routes/_authed/my-players/$tag/clans";
import { Route as AuthedMyClansTagSocialMediaRouteImport } from "./routes/_authed/my-clans/$tag/social-media";
import { Route as AuthedMyClansTagSearchFilterRouteImport } from "./routes/_authed/my-clans/$tag/search-filter";
import { Route as AuthedMyClansTagPlayersRouteImport } from "./routes/_authed/my-clans/$tag/players";
import { Route as AuthedMyClansTagPermissionsRouteImport } from "./routes/_authed/my-clans/$tag/permissions";
import { Route as AuthedMyClansTagNotificationsRouteImport } from "./routes/_authed/my-clans/$tag/notifications";
import { Route as AuthedMyClansTagMatchesRouteImport } from "./routes/_authed/my-clans/$tag/matches";
import { Route as AuthedMyPlayersTagSearchFiltersRouteRouteImport } from "./routes/_authed/my-players/$tag/search-filters/route";
import { Route as AuthedMyPlayersTagClanSearchRouteRouteImport } from "./routes/_authed/my-players/$tag/clan-search/route";
import { Route as AuthedMyClansTagSearchFiltersRouteRouteImport } from "./routes/_authed/my-clans/$tag/search-filters/route";
import { Route as AuthedMyClansTagPlayerSearchRouteRouteImport } from "./routes/_authed/my-clans/$tag/player-search/route";
import { Route as AuthedMyPlayersTagSearchFiltersPersonalRouteImport } from "./routes/_authed/my-players/$tag/search-filters/personal";
import { Route as AuthedMyPlayersTagSearchFiltersGlobalRouteImport } from "./routes/_authed/my-players/$tag/search-filters/global";
import { Route as AuthedMyPlayersTagSearchFiltersApiRouteImport } from "./routes/_authed/my-players/$tag/search-filters/api";
import { Route as AuthedMyPlayersTagClanSearchResultsRouteImport } from "./routes/_authed/my-players/$tag/clan-search/results";
import { Route as AuthedMyPlayersTagClanSearchFiltersRouteImport } from "./routes/_authed/my-players/$tag/clan-search/filters";
import { Route as AuthedMyClansTagSearchFiltersPersonalRouteImport } from "./routes/_authed/my-clans/$tag/search-filters/personal";
import { Route as AuthedMyClansTagSearchFiltersGlobalRouteImport } from "./routes/_authed/my-clans/$tag/search-filters/global";
import { Route as AuthedMyClansTagSearchFiltersApiRouteImport } from "./routes/_authed/my-clans/$tag/search-filters/api";
import { Route as AuthedMyClansTagPlayerSearchResultsRouteImport } from "./routes/_authed/my-clans/$tag/player-search/results";
import { Route as AuthedMyClansTagPlayerSearchFiltersRouteImport } from "./routes/_authed/my-clans/$tag/player-search/filters";

const NotAuthedRouteRoute = NotAuthedRouteRouteImport.update({
  id: "/_not-authed",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const NotAuthedSignUpRoute = NotAuthedSignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => NotAuthedRouteRoute,
} as any);
const NotAuthedSignInRoute = NotAuthedSignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => NotAuthedRouteRoute,
} as any);
const AuthedMyPlayersRouteRoute = AuthedMyPlayersRouteRouteImport.update({
  id: "/my-players",
  path: "/my-players",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedMyClansRouteRoute = AuthedMyClansRouteRouteImport.update({
  id: "/my-clans",
  path: "/my-clans",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedMyPlayersIndexRoute = AuthedMyPlayersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyPlayersRouteRoute,
} as any);
const AuthedMyClansIndexRoute = AuthedMyClansIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyClansRouteRoute,
} as any);
const AuthedClanWarPlannerIndexRoute =
  AuthedClanWarPlannerIndexRouteImport.update({
    id: "/clan-war-planner/",
    path: "/clan-war-planner/",
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedMyPlayersTagRouteRoute = AuthedMyPlayersTagRouteRouteImport.update({
  id: "/$tag",
  path: "/$tag",
  getParentRoute: () => AuthedMyPlayersRouteRoute,
} as any);
const AuthedMyClansTagRouteRoute = AuthedMyClansTagRouteRouteImport.update({
  id: "/$tag",
  path: "/$tag",
  getParentRoute: () => AuthedMyClansRouteRoute,
} as any);
const AuthedMyPlayersTagIndexRoute = AuthedMyPlayersTagIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyPlayersTagRouteRoute,
} as any);
const AuthedMyClansTagIndexRoute = AuthedMyClansTagIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyClansTagRouteRoute,
} as any);
const AuthedMyPlayersTagSocialMediaRoute =
  AuthedMyPlayersTagSocialMediaRouteImport.update({
    id: "/social-media",
    path: "/social-media",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagSearchFilterRoute =
  AuthedMyPlayersTagSearchFilterRouteImport.update({
    id: "/search-filter",
    path: "/search-filter",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagNotificationsRoute =
  AuthedMyPlayersTagNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagMatchsRoute =
  AuthedMyPlayersTagMatchsRouteImport.update({
    id: "/matchs",
    path: "/matchs",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagClansRoute = AuthedMyPlayersTagClansRouteImport.update({
  id: "/clans",
  path: "/clans",
  getParentRoute: () => AuthedMyPlayersTagRouteRoute,
} as any);
const AuthedMyClansTagSocialMediaRoute =
  AuthedMyClansTagSocialMediaRouteImport.update({
    id: "/social-media",
    path: "/social-media",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyClansTagSearchFilterRoute =
  AuthedMyClansTagSearchFilterRouteImport.update({
    id: "/search-filter",
    path: "/search-filter",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyClansTagPlayersRoute = AuthedMyClansTagPlayersRouteImport.update({
  id: "/players",
  path: "/players",
  getParentRoute: () => AuthedMyClansTagRouteRoute,
} as any);
const AuthedMyClansTagPermissionsRoute =
  AuthedMyClansTagPermissionsRouteImport.update({
    id: "/permissions",
    path: "/permissions",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyClansTagNotificationsRoute =
  AuthedMyClansTagNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyClansTagMatchesRoute = AuthedMyClansTagMatchesRouteImport.update({
  id: "/matches",
  path: "/matches",
  getParentRoute: () => AuthedMyClansTagRouteRoute,
} as any);
const AuthedMyPlayersTagSearchFiltersRouteRoute =
  AuthedMyPlayersTagSearchFiltersRouteRouteImport.update({
    id: "/search-filters",
    path: "/search-filters",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagClanSearchRouteRoute =
  AuthedMyPlayersTagClanSearchRouteRouteImport.update({
    id: "/clan-search",
    path: "/clan-search",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyClansTagSearchFiltersRouteRoute =
  AuthedMyClansTagSearchFiltersRouteRouteImport.update({
    id: "/search-filters",
    path: "/search-filters",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyClansTagPlayerSearchRouteRoute =
  AuthedMyClansTagPlayerSearchRouteRouteImport.update({
    id: "/player-search",
    path: "/player-search",
    getParentRoute: () => AuthedMyClansTagRouteRoute,
  } as any);
const AuthedMyPlayersTagSearchFiltersPersonalRoute =
  AuthedMyPlayersTagSearchFiltersPersonalRouteImport.update({
    id: "/personal",
    path: "/personal",
    getParentRoute: () => AuthedMyPlayersTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyPlayersTagSearchFiltersGlobalRoute =
  AuthedMyPlayersTagSearchFiltersGlobalRouteImport.update({
    id: "/global",
    path: "/global",
    getParentRoute: () => AuthedMyPlayersTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyPlayersTagSearchFiltersApiRoute =
  AuthedMyPlayersTagSearchFiltersApiRouteImport.update({
    id: "/api",
    path: "/api",
    getParentRoute: () => AuthedMyPlayersTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyPlayersTagClanSearchResultsRoute =
  AuthedMyPlayersTagClanSearchResultsRouteImport.update({
    id: "/results",
    path: "/results",
    getParentRoute: () => AuthedMyPlayersTagClanSearchRouteRoute,
  } as any);
const AuthedMyPlayersTagClanSearchFiltersRoute =
  AuthedMyPlayersTagClanSearchFiltersRouteImport.update({
    id: "/filters",
    path: "/filters",
    getParentRoute: () => AuthedMyPlayersTagClanSearchRouteRoute,
  } as any);
const AuthedMyClansTagSearchFiltersPersonalRoute =
  AuthedMyClansTagSearchFiltersPersonalRouteImport.update({
    id: "/personal",
    path: "/personal",
    getParentRoute: () => AuthedMyClansTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyClansTagSearchFiltersGlobalRoute =
  AuthedMyClansTagSearchFiltersGlobalRouteImport.update({
    id: "/global",
    path: "/global",
    getParentRoute: () => AuthedMyClansTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyClansTagSearchFiltersApiRoute =
  AuthedMyClansTagSearchFiltersApiRouteImport.update({
    id: "/api",
    path: "/api",
    getParentRoute: () => AuthedMyClansTagSearchFiltersRouteRoute,
  } as any);
const AuthedMyClansTagPlayerSearchResultsRoute =
  AuthedMyClansTagPlayerSearchResultsRouteImport.update({
    id: "/results",
    path: "/results",
    getParentRoute: () => AuthedMyClansTagPlayerSearchRouteRoute,
  } as any);
const AuthedMyClansTagPlayerSearchFiltersRoute =
  AuthedMyClansTagPlayerSearchFiltersRouteImport.update({
    id: "/filters",
    path: "/filters",
    getParentRoute: () => AuthedMyClansTagPlayerSearchRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute;
  "/my-clans": typeof AuthedMyClansRouteRouteWithChildren;
  "/my-players": typeof AuthedMyPlayersRouteRouteWithChildren;
  "/sign-in": typeof NotAuthedSignInRoute;
  "/sign-up": typeof NotAuthedSignUpRoute;
  "/my-clans/$tag": typeof AuthedMyClansTagRouteRouteWithChildren;
  "/my-players/$tag": typeof AuthedMyPlayersTagRouteRouteWithChildren;
  "/clan-war-planner/": typeof AuthedClanWarPlannerIndexRoute;
  "/my-clans/": typeof AuthedMyClansIndexRoute;
  "/my-players/": typeof AuthedMyPlayersIndexRoute;
  "/my-clans/$tag/player-search": typeof AuthedMyClansTagPlayerSearchRouteRouteWithChildren;
  "/my-clans/$tag/search-filters": typeof AuthedMyClansTagSearchFiltersRouteRouteWithChildren;
  "/my-players/$tag/clan-search": typeof AuthedMyPlayersTagClanSearchRouteRouteWithChildren;
  "/my-players/$tag/search-filters": typeof AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren;
  "/my-clans/$tag/matches": typeof AuthedMyClansTagMatchesRoute;
  "/my-clans/$tag/notifications": typeof AuthedMyClansTagNotificationsRoute;
  "/my-clans/$tag/permissions": typeof AuthedMyClansTagPermissionsRoute;
  "/my-clans/$tag/players": typeof AuthedMyClansTagPlayersRoute;
  "/my-clans/$tag/search-filter": typeof AuthedMyClansTagSearchFilterRoute;
  "/my-clans/$tag/social-media": typeof AuthedMyClansTagSocialMediaRoute;
  "/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/my-clans/$tag/": typeof AuthedMyClansTagIndexRoute;
  "/my-players/$tag/": typeof AuthedMyPlayersTagIndexRoute;
  "/my-clans/$tag/player-search/filters": typeof AuthedMyClansTagPlayerSearchFiltersRoute;
  "/my-clans/$tag/player-search/results": typeof AuthedMyClansTagPlayerSearchResultsRoute;
  "/my-clans/$tag/search-filters/api": typeof AuthedMyClansTagSearchFiltersApiRoute;
  "/my-clans/$tag/search-filters/global": typeof AuthedMyClansTagSearchFiltersGlobalRoute;
  "/my-clans/$tag/search-filters/personal": typeof AuthedMyClansTagSearchFiltersPersonalRoute;
  "/my-players/$tag/clan-search/filters": typeof AuthedMyPlayersTagClanSearchFiltersRoute;
  "/my-players/$tag/clan-search/results": typeof AuthedMyPlayersTagClanSearchResultsRoute;
  "/my-players/$tag/search-filters/api": typeof AuthedMyPlayersTagSearchFiltersApiRoute;
  "/my-players/$tag/search-filters/global": typeof AuthedMyPlayersTagSearchFiltersGlobalRoute;
  "/my-players/$tag/search-filters/personal": typeof AuthedMyPlayersTagSearchFiltersPersonalRoute;
}
export interface FileRoutesByTo {
  "/": typeof AuthedIndexRoute;
  "/sign-in": typeof NotAuthedSignInRoute;
  "/sign-up": typeof NotAuthedSignUpRoute;
  "/clan-war-planner": typeof AuthedClanWarPlannerIndexRoute;
  "/my-clans": typeof AuthedMyClansIndexRoute;
  "/my-players": typeof AuthedMyPlayersIndexRoute;
  "/my-clans/$tag/player-search": typeof AuthedMyClansTagPlayerSearchRouteRouteWithChildren;
  "/my-clans/$tag/search-filters": typeof AuthedMyClansTagSearchFiltersRouteRouteWithChildren;
  "/my-players/$tag/clan-search": typeof AuthedMyPlayersTagClanSearchRouteRouteWithChildren;
  "/my-players/$tag/search-filters": typeof AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren;
  "/my-clans/$tag/matches": typeof AuthedMyClansTagMatchesRoute;
  "/my-clans/$tag/notifications": typeof AuthedMyClansTagNotificationsRoute;
  "/my-clans/$tag/permissions": typeof AuthedMyClansTagPermissionsRoute;
  "/my-clans/$tag/players": typeof AuthedMyClansTagPlayersRoute;
  "/my-clans/$tag/search-filter": typeof AuthedMyClansTagSearchFilterRoute;
  "/my-clans/$tag/social-media": typeof AuthedMyClansTagSocialMediaRoute;
  "/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/my-clans/$tag": typeof AuthedMyClansTagIndexRoute;
  "/my-players/$tag": typeof AuthedMyPlayersTagIndexRoute;
  "/my-clans/$tag/player-search/filters": typeof AuthedMyClansTagPlayerSearchFiltersRoute;
  "/my-clans/$tag/player-search/results": typeof AuthedMyClansTagPlayerSearchResultsRoute;
  "/my-clans/$tag/search-filters/api": typeof AuthedMyClansTagSearchFiltersApiRoute;
  "/my-clans/$tag/search-filters/global": typeof AuthedMyClansTagSearchFiltersGlobalRoute;
  "/my-clans/$tag/search-filters/personal": typeof AuthedMyClansTagSearchFiltersPersonalRoute;
  "/my-players/$tag/clan-search/filters": typeof AuthedMyPlayersTagClanSearchFiltersRoute;
  "/my-players/$tag/clan-search/results": typeof AuthedMyPlayersTagClanSearchResultsRoute;
  "/my-players/$tag/search-filters/api": typeof AuthedMyPlayersTagSearchFiltersApiRoute;
  "/my-players/$tag/search-filters/global": typeof AuthedMyPlayersTagSearchFiltersGlobalRoute;
  "/my-players/$tag/search-filters/personal": typeof AuthedMyPlayersTagSearchFiltersPersonalRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authed": typeof AuthedRouteRouteWithChildren;
  "/_not-authed": typeof NotAuthedRouteRouteWithChildren;
  "/_authed/my-clans": typeof AuthedMyClansRouteRouteWithChildren;
  "/_authed/my-players": typeof AuthedMyPlayersRouteRouteWithChildren;
  "/_not-authed/sign-in": typeof NotAuthedSignInRoute;
  "/_not-authed/sign-up": typeof NotAuthedSignUpRoute;
  "/_authed/": typeof AuthedIndexRoute;
  "/_authed/my-clans/$tag": typeof AuthedMyClansTagRouteRouteWithChildren;
  "/_authed/my-players/$tag": typeof AuthedMyPlayersTagRouteRouteWithChildren;
  "/_authed/clan-war-planner/": typeof AuthedClanWarPlannerIndexRoute;
  "/_authed/my-clans/": typeof AuthedMyClansIndexRoute;
  "/_authed/my-players/": typeof AuthedMyPlayersIndexRoute;
  "/_authed/my-clans/$tag/player-search": typeof AuthedMyClansTagPlayerSearchRouteRouteWithChildren;
  "/_authed/my-clans/$tag/search-filters": typeof AuthedMyClansTagSearchFiltersRouteRouteWithChildren;
  "/_authed/my-players/$tag/clan-search": typeof AuthedMyPlayersTagClanSearchRouteRouteWithChildren;
  "/_authed/my-players/$tag/search-filters": typeof AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren;
  "/_authed/my-clans/$tag/matches": typeof AuthedMyClansTagMatchesRoute;
  "/_authed/my-clans/$tag/notifications": typeof AuthedMyClansTagNotificationsRoute;
  "/_authed/my-clans/$tag/permissions": typeof AuthedMyClansTagPermissionsRoute;
  "/_authed/my-clans/$tag/players": typeof AuthedMyClansTagPlayersRoute;
  "/_authed/my-clans/$tag/search-filter": typeof AuthedMyClansTagSearchFilterRoute;
  "/_authed/my-clans/$tag/social-media": typeof AuthedMyClansTagSocialMediaRoute;
  "/_authed/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/_authed/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/_authed/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/_authed/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/_authed/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/_authed/my-clans/$tag/": typeof AuthedMyClansTagIndexRoute;
  "/_authed/my-players/$tag/": typeof AuthedMyPlayersTagIndexRoute;
  "/_authed/my-clans/$tag/player-search/filters": typeof AuthedMyClansTagPlayerSearchFiltersRoute;
  "/_authed/my-clans/$tag/player-search/results": typeof AuthedMyClansTagPlayerSearchResultsRoute;
  "/_authed/my-clans/$tag/search-filters/api": typeof AuthedMyClansTagSearchFiltersApiRoute;
  "/_authed/my-clans/$tag/search-filters/global": typeof AuthedMyClansTagSearchFiltersGlobalRoute;
  "/_authed/my-clans/$tag/search-filters/personal": typeof AuthedMyClansTagSearchFiltersPersonalRoute;
  "/_authed/my-players/$tag/clan-search/filters": typeof AuthedMyPlayersTagClanSearchFiltersRoute;
  "/_authed/my-players/$tag/clan-search/results": typeof AuthedMyPlayersTagClanSearchResultsRoute;
  "/_authed/my-players/$tag/search-filters/api": typeof AuthedMyPlayersTagSearchFiltersApiRoute;
  "/_authed/my-players/$tag/search-filters/global": typeof AuthedMyPlayersTagSearchFiltersGlobalRoute;
  "/_authed/my-players/$tag/search-filters/personal": typeof AuthedMyPlayersTagSearchFiltersPersonalRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/my-clans"
    | "/my-players"
    | "/sign-in"
    | "/sign-up"
    | "/my-clans/$tag"
    | "/my-players/$tag"
    | "/clan-war-planner/"
    | "/my-clans/"
    | "/my-players/"
    | "/my-clans/$tag/player-search"
    | "/my-clans/$tag/search-filters"
    | "/my-players/$tag/clan-search"
    | "/my-players/$tag/search-filters"
    | "/my-clans/$tag/matches"
    | "/my-clans/$tag/notifications"
    | "/my-clans/$tag/permissions"
    | "/my-clans/$tag/players"
    | "/my-clans/$tag/search-filter"
    | "/my-clans/$tag/social-media"
    | "/my-players/$tag/clans"
    | "/my-players/$tag/matchs"
    | "/my-players/$tag/notifications"
    | "/my-players/$tag/search-filter"
    | "/my-players/$tag/social-media"
    | "/my-clans/$tag/"
    | "/my-players/$tag/"
    | "/my-clans/$tag/player-search/filters"
    | "/my-clans/$tag/player-search/results"
    | "/my-clans/$tag/search-filters/api"
    | "/my-clans/$tag/search-filters/global"
    | "/my-clans/$tag/search-filters/personal"
    | "/my-players/$tag/clan-search/filters"
    | "/my-players/$tag/clan-search/results"
    | "/my-players/$tag/search-filters/api"
    | "/my-players/$tag/search-filters/global"
    | "/my-players/$tag/search-filters/personal";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/sign-in"
    | "/sign-up"
    | "/clan-war-planner"
    | "/my-clans"
    | "/my-players"
    | "/my-clans/$tag/player-search"
    | "/my-clans/$tag/search-filters"
    | "/my-players/$tag/clan-search"
    | "/my-players/$tag/search-filters"
    | "/my-clans/$tag/matches"
    | "/my-clans/$tag/notifications"
    | "/my-clans/$tag/permissions"
    | "/my-clans/$tag/players"
    | "/my-clans/$tag/search-filter"
    | "/my-clans/$tag/social-media"
    | "/my-players/$tag/clans"
    | "/my-players/$tag/matchs"
    | "/my-players/$tag/notifications"
    | "/my-players/$tag/search-filter"
    | "/my-players/$tag/social-media"
    | "/my-clans/$tag"
    | "/my-players/$tag"
    | "/my-clans/$tag/player-search/filters"
    | "/my-clans/$tag/player-search/results"
    | "/my-clans/$tag/search-filters/api"
    | "/my-clans/$tag/search-filters/global"
    | "/my-clans/$tag/search-filters/personal"
    | "/my-players/$tag/clan-search/filters"
    | "/my-players/$tag/clan-search/results"
    | "/my-players/$tag/search-filters/api"
    | "/my-players/$tag/search-filters/global"
    | "/my-players/$tag/search-filters/personal";
  id:
    | "__root__"
    | "/_authed"
    | "/_not-authed"
    | "/_authed/my-clans"
    | "/_authed/my-players"
    | "/_not-authed/sign-in"
    | "/_not-authed/sign-up"
    | "/_authed/"
    | "/_authed/my-clans/$tag"
    | "/_authed/my-players/$tag"
    | "/_authed/clan-war-planner/"
    | "/_authed/my-clans/"
    | "/_authed/my-players/"
    | "/_authed/my-clans/$tag/player-search"
    | "/_authed/my-clans/$tag/search-filters"
    | "/_authed/my-players/$tag/clan-search"
    | "/_authed/my-players/$tag/search-filters"
    | "/_authed/my-clans/$tag/matches"
    | "/_authed/my-clans/$tag/notifications"
    | "/_authed/my-clans/$tag/permissions"
    | "/_authed/my-clans/$tag/players"
    | "/_authed/my-clans/$tag/search-filter"
    | "/_authed/my-clans/$tag/social-media"
    | "/_authed/my-players/$tag/clans"
    | "/_authed/my-players/$tag/matchs"
    | "/_authed/my-players/$tag/notifications"
    | "/_authed/my-players/$tag/search-filter"
    | "/_authed/my-players/$tag/social-media"
    | "/_authed/my-clans/$tag/"
    | "/_authed/my-players/$tag/"
    | "/_authed/my-clans/$tag/player-search/filters"
    | "/_authed/my-clans/$tag/player-search/results"
    | "/_authed/my-clans/$tag/search-filters/api"
    | "/_authed/my-clans/$tag/search-filters/global"
    | "/_authed/my-clans/$tag/search-filters/personal"
    | "/_authed/my-players/$tag/clan-search/filters"
    | "/_authed/my-players/$tag/clan-search/results"
    | "/_authed/my-players/$tag/search-filters/api"
    | "/_authed/my-players/$tag/search-filters/global"
    | "/_authed/my-players/$tag/search-filters/personal";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren;
  NotAuthedRouteRoute: typeof NotAuthedRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_not-authed": {
      id: "/_not-authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof NotAuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/": {
      id: "/_authed/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthedIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_not-authed/sign-up": {
      id: "/_not-authed/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof NotAuthedSignUpRouteImport;
      parentRoute: typeof NotAuthedRouteRoute;
    };
    "/_not-authed/sign-in": {
      id: "/_not-authed/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof NotAuthedSignInRouteImport;
      parentRoute: typeof NotAuthedRouteRoute;
    };
    "/_authed/my-players": {
      id: "/_authed/my-players";
      path: "/my-players";
      fullPath: "/my-players";
      preLoaderRoute: typeof AuthedMyPlayersRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-clans": {
      id: "/_authed/my-clans";
      path: "/my-clans";
      fullPath: "/my-clans";
      preLoaderRoute: typeof AuthedMyClansRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-players/": {
      id: "/_authed/my-players/";
      path: "/";
      fullPath: "/my-players/";
      preLoaderRoute: typeof AuthedMyPlayersIndexRouteImport;
      parentRoute: typeof AuthedMyPlayersRouteRoute;
    };
    "/_authed/my-clans/": {
      id: "/_authed/my-clans/";
      path: "/";
      fullPath: "/my-clans/";
      preLoaderRoute: typeof AuthedMyClansIndexRouteImport;
      parentRoute: typeof AuthedMyClansRouteRoute;
    };
    "/_authed/clan-war-planner/": {
      id: "/_authed/clan-war-planner/";
      path: "/clan-war-planner";
      fullPath: "/clan-war-planner/";
      preLoaderRoute: typeof AuthedClanWarPlannerIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-players/$tag": {
      id: "/_authed/my-players/$tag";
      path: "/$tag";
      fullPath: "/my-players/$tag";
      preLoaderRoute: typeof AuthedMyPlayersTagRouteRouteImport;
      parentRoute: typeof AuthedMyPlayersRouteRoute;
    };
    "/_authed/my-clans/$tag": {
      id: "/_authed/my-clans/$tag";
      path: "/$tag";
      fullPath: "/my-clans/$tag";
      preLoaderRoute: typeof AuthedMyClansTagRouteRouteImport;
      parentRoute: typeof AuthedMyClansRouteRoute;
    };
    "/_authed/my-players/$tag/": {
      id: "/_authed/my-players/$tag/";
      path: "/";
      fullPath: "/my-players/$tag/";
      preLoaderRoute: typeof AuthedMyPlayersTagIndexRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-clans/$tag/": {
      id: "/_authed/my-clans/$tag/";
      path: "/";
      fullPath: "/my-clans/$tag/";
      preLoaderRoute: typeof AuthedMyClansTagIndexRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-players/$tag/social-media": {
      id: "/_authed/my-players/$tag/social-media";
      path: "/social-media";
      fullPath: "/my-players/$tag/social-media";
      preLoaderRoute: typeof AuthedMyPlayersTagSocialMediaRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/search-filter": {
      id: "/_authed/my-players/$tag/search-filter";
      path: "/search-filter";
      fullPath: "/my-players/$tag/search-filter";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFilterRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/notifications": {
      id: "/_authed/my-players/$tag/notifications";
      path: "/notifications";
      fullPath: "/my-players/$tag/notifications";
      preLoaderRoute: typeof AuthedMyPlayersTagNotificationsRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/matchs": {
      id: "/_authed/my-players/$tag/matchs";
      path: "/matchs";
      fullPath: "/my-players/$tag/matchs";
      preLoaderRoute: typeof AuthedMyPlayersTagMatchsRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/clans": {
      id: "/_authed/my-players/$tag/clans";
      path: "/clans";
      fullPath: "/my-players/$tag/clans";
      preLoaderRoute: typeof AuthedMyPlayersTagClansRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-clans/$tag/social-media": {
      id: "/_authed/my-clans/$tag/social-media";
      path: "/social-media";
      fullPath: "/my-clans/$tag/social-media";
      preLoaderRoute: typeof AuthedMyClansTagSocialMediaRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/search-filter": {
      id: "/_authed/my-clans/$tag/search-filter";
      path: "/search-filter";
      fullPath: "/my-clans/$tag/search-filter";
      preLoaderRoute: typeof AuthedMyClansTagSearchFilterRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/players": {
      id: "/_authed/my-clans/$tag/players";
      path: "/players";
      fullPath: "/my-clans/$tag/players";
      preLoaderRoute: typeof AuthedMyClansTagPlayersRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/permissions": {
      id: "/_authed/my-clans/$tag/permissions";
      path: "/permissions";
      fullPath: "/my-clans/$tag/permissions";
      preLoaderRoute: typeof AuthedMyClansTagPermissionsRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/notifications": {
      id: "/_authed/my-clans/$tag/notifications";
      path: "/notifications";
      fullPath: "/my-clans/$tag/notifications";
      preLoaderRoute: typeof AuthedMyClansTagNotificationsRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/matches": {
      id: "/_authed/my-clans/$tag/matches";
      path: "/matches";
      fullPath: "/my-clans/$tag/matches";
      preLoaderRoute: typeof AuthedMyClansTagMatchesRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-players/$tag/search-filters": {
      id: "/_authed/my-players/$tag/search-filters";
      path: "/search-filters";
      fullPath: "/my-players/$tag/search-filters";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFiltersRouteRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/clan-search": {
      id: "/_authed/my-players/$tag/clan-search";
      path: "/clan-search";
      fullPath: "/my-players/$tag/clan-search";
      preLoaderRoute: typeof AuthedMyPlayersTagClanSearchRouteRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-clans/$tag/search-filters": {
      id: "/_authed/my-clans/$tag/search-filters";
      path: "/search-filters";
      fullPath: "/my-clans/$tag/search-filters";
      preLoaderRoute: typeof AuthedMyClansTagSearchFiltersRouteRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-clans/$tag/player-search": {
      id: "/_authed/my-clans/$tag/player-search";
      path: "/player-search";
      fullPath: "/my-clans/$tag/player-search";
      preLoaderRoute: typeof AuthedMyClansTagPlayerSearchRouteRouteImport;
      parentRoute: typeof AuthedMyClansTagRouteRoute;
    };
    "/_authed/my-players/$tag/search-filters/personal": {
      id: "/_authed/my-players/$tag/search-filters/personal";
      path: "/personal";
      fullPath: "/my-players/$tag/search-filters/personal";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFiltersPersonalRouteImport;
      parentRoute: typeof AuthedMyPlayersTagSearchFiltersRouteRoute;
    };
    "/_authed/my-players/$tag/search-filters/global": {
      id: "/_authed/my-players/$tag/search-filters/global";
      path: "/global";
      fullPath: "/my-players/$tag/search-filters/global";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFiltersGlobalRouteImport;
      parentRoute: typeof AuthedMyPlayersTagSearchFiltersRouteRoute;
    };
    "/_authed/my-players/$tag/search-filters/api": {
      id: "/_authed/my-players/$tag/search-filters/api";
      path: "/api";
      fullPath: "/my-players/$tag/search-filters/api";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFiltersApiRouteImport;
      parentRoute: typeof AuthedMyPlayersTagSearchFiltersRouteRoute;
    };
    "/_authed/my-players/$tag/clan-search/results": {
      id: "/_authed/my-players/$tag/clan-search/results";
      path: "/results";
      fullPath: "/my-players/$tag/clan-search/results";
      preLoaderRoute: typeof AuthedMyPlayersTagClanSearchResultsRouteImport;
      parentRoute: typeof AuthedMyPlayersTagClanSearchRouteRoute;
    };
    "/_authed/my-players/$tag/clan-search/filters": {
      id: "/_authed/my-players/$tag/clan-search/filters";
      path: "/filters";
      fullPath: "/my-players/$tag/clan-search/filters";
      preLoaderRoute: typeof AuthedMyPlayersTagClanSearchFiltersRouteImport;
      parentRoute: typeof AuthedMyPlayersTagClanSearchRouteRoute;
    };
    "/_authed/my-clans/$tag/search-filters/personal": {
      id: "/_authed/my-clans/$tag/search-filters/personal";
      path: "/personal";
      fullPath: "/my-clans/$tag/search-filters/personal";
      preLoaderRoute: typeof AuthedMyClansTagSearchFiltersPersonalRouteImport;
      parentRoute: typeof AuthedMyClansTagSearchFiltersRouteRoute;
    };
    "/_authed/my-clans/$tag/search-filters/global": {
      id: "/_authed/my-clans/$tag/search-filters/global";
      path: "/global";
      fullPath: "/my-clans/$tag/search-filters/global";
      preLoaderRoute: typeof AuthedMyClansTagSearchFiltersGlobalRouteImport;
      parentRoute: typeof AuthedMyClansTagSearchFiltersRouteRoute;
    };
    "/_authed/my-clans/$tag/search-filters/api": {
      id: "/_authed/my-clans/$tag/search-filters/api";
      path: "/api";
      fullPath: "/my-clans/$tag/search-filters/api";
      preLoaderRoute: typeof AuthedMyClansTagSearchFiltersApiRouteImport;
      parentRoute: typeof AuthedMyClansTagSearchFiltersRouteRoute;
    };
    "/_authed/my-clans/$tag/player-search/results": {
      id: "/_authed/my-clans/$tag/player-search/results";
      path: "/results";
      fullPath: "/my-clans/$tag/player-search/results";
      preLoaderRoute: typeof AuthedMyClansTagPlayerSearchResultsRouteImport;
      parentRoute: typeof AuthedMyClansTagPlayerSearchRouteRoute;
    };
    "/_authed/my-clans/$tag/player-search/filters": {
      id: "/_authed/my-clans/$tag/player-search/filters";
      path: "/filters";
      fullPath: "/my-clans/$tag/player-search/filters";
      preLoaderRoute: typeof AuthedMyClansTagPlayerSearchFiltersRouteImport;
      parentRoute: typeof AuthedMyClansTagPlayerSearchRouteRoute;
    };
  }
}

interface AuthedMyClansTagPlayerSearchRouteRouteChildren {
  AuthedMyClansTagPlayerSearchFiltersRoute: typeof AuthedMyClansTagPlayerSearchFiltersRoute;
  AuthedMyClansTagPlayerSearchResultsRoute: typeof AuthedMyClansTagPlayerSearchResultsRoute;
}

const AuthedMyClansTagPlayerSearchRouteRouteChildren: AuthedMyClansTagPlayerSearchRouteRouteChildren =
  {
    AuthedMyClansTagPlayerSearchFiltersRoute:
      AuthedMyClansTagPlayerSearchFiltersRoute,
    AuthedMyClansTagPlayerSearchResultsRoute:
      AuthedMyClansTagPlayerSearchResultsRoute,
  };

const AuthedMyClansTagPlayerSearchRouteRouteWithChildren =
  AuthedMyClansTagPlayerSearchRouteRoute._addFileChildren(
    AuthedMyClansTagPlayerSearchRouteRouteChildren,
  );

interface AuthedMyClansTagSearchFiltersRouteRouteChildren {
  AuthedMyClansTagSearchFiltersApiRoute: typeof AuthedMyClansTagSearchFiltersApiRoute;
  AuthedMyClansTagSearchFiltersGlobalRoute: typeof AuthedMyClansTagSearchFiltersGlobalRoute;
  AuthedMyClansTagSearchFiltersPersonalRoute: typeof AuthedMyClansTagSearchFiltersPersonalRoute;
}

const AuthedMyClansTagSearchFiltersRouteRouteChildren: AuthedMyClansTagSearchFiltersRouteRouteChildren =
  {
    AuthedMyClansTagSearchFiltersApiRoute:
      AuthedMyClansTagSearchFiltersApiRoute,
    AuthedMyClansTagSearchFiltersGlobalRoute:
      AuthedMyClansTagSearchFiltersGlobalRoute,
    AuthedMyClansTagSearchFiltersPersonalRoute:
      AuthedMyClansTagSearchFiltersPersonalRoute,
  };

const AuthedMyClansTagSearchFiltersRouteRouteWithChildren =
  AuthedMyClansTagSearchFiltersRouteRoute._addFileChildren(
    AuthedMyClansTagSearchFiltersRouteRouteChildren,
  );

interface AuthedMyClansTagRouteRouteChildren {
  AuthedMyClansTagPlayerSearchRouteRoute: typeof AuthedMyClansTagPlayerSearchRouteRouteWithChildren;
  AuthedMyClansTagSearchFiltersRouteRoute: typeof AuthedMyClansTagSearchFiltersRouteRouteWithChildren;
  AuthedMyClansTagMatchesRoute: typeof AuthedMyClansTagMatchesRoute;
  AuthedMyClansTagNotificationsRoute: typeof AuthedMyClansTagNotificationsRoute;
  AuthedMyClansTagPermissionsRoute: typeof AuthedMyClansTagPermissionsRoute;
  AuthedMyClansTagPlayersRoute: typeof AuthedMyClansTagPlayersRoute;
  AuthedMyClansTagSearchFilterRoute: typeof AuthedMyClansTagSearchFilterRoute;
  AuthedMyClansTagSocialMediaRoute: typeof AuthedMyClansTagSocialMediaRoute;
  AuthedMyClansTagIndexRoute: typeof AuthedMyClansTagIndexRoute;
}

const AuthedMyClansTagRouteRouteChildren: AuthedMyClansTagRouteRouteChildren = {
  AuthedMyClansTagPlayerSearchRouteRoute:
    AuthedMyClansTagPlayerSearchRouteRouteWithChildren,
  AuthedMyClansTagSearchFiltersRouteRoute:
    AuthedMyClansTagSearchFiltersRouteRouteWithChildren,
  AuthedMyClansTagMatchesRoute: AuthedMyClansTagMatchesRoute,
  AuthedMyClansTagNotificationsRoute: AuthedMyClansTagNotificationsRoute,
  AuthedMyClansTagPermissionsRoute: AuthedMyClansTagPermissionsRoute,
  AuthedMyClansTagPlayersRoute: AuthedMyClansTagPlayersRoute,
  AuthedMyClansTagSearchFilterRoute: AuthedMyClansTagSearchFilterRoute,
  AuthedMyClansTagSocialMediaRoute: AuthedMyClansTagSocialMediaRoute,
  AuthedMyClansTagIndexRoute: AuthedMyClansTagIndexRoute,
};

const AuthedMyClansTagRouteRouteWithChildren =
  AuthedMyClansTagRouteRoute._addFileChildren(
    AuthedMyClansTagRouteRouteChildren,
  );

interface AuthedMyClansRouteRouteChildren {
  AuthedMyClansTagRouteRoute: typeof AuthedMyClansTagRouteRouteWithChildren;
  AuthedMyClansIndexRoute: typeof AuthedMyClansIndexRoute;
}

const AuthedMyClansRouteRouteChildren: AuthedMyClansRouteRouteChildren = {
  AuthedMyClansTagRouteRoute: AuthedMyClansTagRouteRouteWithChildren,
  AuthedMyClansIndexRoute: AuthedMyClansIndexRoute,
};

const AuthedMyClansRouteRouteWithChildren =
  AuthedMyClansRouteRoute._addFileChildren(AuthedMyClansRouteRouteChildren);

interface AuthedMyPlayersTagClanSearchRouteRouteChildren {
  AuthedMyPlayersTagClanSearchFiltersRoute: typeof AuthedMyPlayersTagClanSearchFiltersRoute;
  AuthedMyPlayersTagClanSearchResultsRoute: typeof AuthedMyPlayersTagClanSearchResultsRoute;
}

const AuthedMyPlayersTagClanSearchRouteRouteChildren: AuthedMyPlayersTagClanSearchRouteRouteChildren =
  {
    AuthedMyPlayersTagClanSearchFiltersRoute:
      AuthedMyPlayersTagClanSearchFiltersRoute,
    AuthedMyPlayersTagClanSearchResultsRoute:
      AuthedMyPlayersTagClanSearchResultsRoute,
  };

const AuthedMyPlayersTagClanSearchRouteRouteWithChildren =
  AuthedMyPlayersTagClanSearchRouteRoute._addFileChildren(
    AuthedMyPlayersTagClanSearchRouteRouteChildren,
  );

interface AuthedMyPlayersTagSearchFiltersRouteRouteChildren {
  AuthedMyPlayersTagSearchFiltersApiRoute: typeof AuthedMyPlayersTagSearchFiltersApiRoute;
  AuthedMyPlayersTagSearchFiltersGlobalRoute: typeof AuthedMyPlayersTagSearchFiltersGlobalRoute;
  AuthedMyPlayersTagSearchFiltersPersonalRoute: typeof AuthedMyPlayersTagSearchFiltersPersonalRoute;
}

const AuthedMyPlayersTagSearchFiltersRouteRouteChildren: AuthedMyPlayersTagSearchFiltersRouteRouteChildren =
  {
    AuthedMyPlayersTagSearchFiltersApiRoute:
      AuthedMyPlayersTagSearchFiltersApiRoute,
    AuthedMyPlayersTagSearchFiltersGlobalRoute:
      AuthedMyPlayersTagSearchFiltersGlobalRoute,
    AuthedMyPlayersTagSearchFiltersPersonalRoute:
      AuthedMyPlayersTagSearchFiltersPersonalRoute,
  };

const AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren =
  AuthedMyPlayersTagSearchFiltersRouteRoute._addFileChildren(
    AuthedMyPlayersTagSearchFiltersRouteRouteChildren,
  );

interface AuthedMyPlayersTagRouteRouteChildren {
  AuthedMyPlayersTagClanSearchRouteRoute: typeof AuthedMyPlayersTagClanSearchRouteRouteWithChildren;
  AuthedMyPlayersTagSearchFiltersRouteRoute: typeof AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren;
  AuthedMyPlayersTagClansRoute: typeof AuthedMyPlayersTagClansRoute;
  AuthedMyPlayersTagMatchsRoute: typeof AuthedMyPlayersTagMatchsRoute;
  AuthedMyPlayersTagNotificationsRoute: typeof AuthedMyPlayersTagNotificationsRoute;
  AuthedMyPlayersTagSearchFilterRoute: typeof AuthedMyPlayersTagSearchFilterRoute;
  AuthedMyPlayersTagSocialMediaRoute: typeof AuthedMyPlayersTagSocialMediaRoute;
  AuthedMyPlayersTagIndexRoute: typeof AuthedMyPlayersTagIndexRoute;
}

const AuthedMyPlayersTagRouteRouteChildren: AuthedMyPlayersTagRouteRouteChildren =
  {
    AuthedMyPlayersTagClanSearchRouteRoute:
      AuthedMyPlayersTagClanSearchRouteRouteWithChildren,
    AuthedMyPlayersTagSearchFiltersRouteRoute:
      AuthedMyPlayersTagSearchFiltersRouteRouteWithChildren,
    AuthedMyPlayersTagClansRoute: AuthedMyPlayersTagClansRoute,
    AuthedMyPlayersTagMatchsRoute: AuthedMyPlayersTagMatchsRoute,
    AuthedMyPlayersTagNotificationsRoute: AuthedMyPlayersTagNotificationsRoute,
    AuthedMyPlayersTagSearchFilterRoute: AuthedMyPlayersTagSearchFilterRoute,
    AuthedMyPlayersTagSocialMediaRoute: AuthedMyPlayersTagSocialMediaRoute,
    AuthedMyPlayersTagIndexRoute: AuthedMyPlayersTagIndexRoute,
  };

const AuthedMyPlayersTagRouteRouteWithChildren =
  AuthedMyPlayersTagRouteRoute._addFileChildren(
    AuthedMyPlayersTagRouteRouteChildren,
  );

interface AuthedMyPlayersRouteRouteChildren {
  AuthedMyPlayersTagRouteRoute: typeof AuthedMyPlayersTagRouteRouteWithChildren;
  AuthedMyPlayersIndexRoute: typeof AuthedMyPlayersIndexRoute;
}

const AuthedMyPlayersRouteRouteChildren: AuthedMyPlayersRouteRouteChildren = {
  AuthedMyPlayersTagRouteRoute: AuthedMyPlayersTagRouteRouteWithChildren,
  AuthedMyPlayersIndexRoute: AuthedMyPlayersIndexRoute,
};

const AuthedMyPlayersRouteRouteWithChildren =
  AuthedMyPlayersRouteRoute._addFileChildren(AuthedMyPlayersRouteRouteChildren);

interface AuthedRouteRouteChildren {
  AuthedMyClansRouteRoute: typeof AuthedMyClansRouteRouteWithChildren;
  AuthedMyPlayersRouteRoute: typeof AuthedMyPlayersRouteRouteWithChildren;
  AuthedIndexRoute: typeof AuthedIndexRoute;
  AuthedClanWarPlannerIndexRoute: typeof AuthedClanWarPlannerIndexRoute;
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedMyClansRouteRoute: AuthedMyClansRouteRouteWithChildren,
  AuthedMyPlayersRouteRoute: AuthedMyPlayersRouteRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedClanWarPlannerIndexRoute: AuthedClanWarPlannerIndexRoute,
};

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
);

interface NotAuthedRouteRouteChildren {
  NotAuthedSignInRoute: typeof NotAuthedSignInRoute;
  NotAuthedSignUpRoute: typeof NotAuthedSignUpRoute;
}

const NotAuthedRouteRouteChildren: NotAuthedRouteRouteChildren = {
  NotAuthedSignInRoute: NotAuthedSignInRoute,
  NotAuthedSignUpRoute: NotAuthedSignUpRoute,
};

const NotAuthedRouteRouteWithChildren = NotAuthedRouteRoute._addFileChildren(
  NotAuthedRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  NotAuthedRouteRoute: NotAuthedRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
